import { PlaceholderPage } from './PlaceholderPage';

export const GeneralLedgerOverviewPage = () => <PlaceholderPage title="Overview" />;
